export default function productdata(){
    return [
  {
    id: 1,
    name: "Aata Biscuit",
    category: "Biscuit",
    quantity: 12,
    price: 95.97,
    image: "https://images.pexels.com/photos/4110005/pexels-photo-4110005.jpeg",
    description: "Healthy whole wheat biscuits made with premium quality atta. Perfect for breakfast or evening snacks.",
    brand: "Healthy Bites",
    weight: "500g",
    expiryDate: "2024-12-31",
    ingredients: ["Whole Wheat Flour", "Sugar", "Vegetable Oil", "Salt", "Baking Soda"],
    nutritionalInfo: {
      calories: "120 kcal",
      protein: "2g",
      carbs: "18g",
      fat: "4g"
    },
    storage: "Store in a cool, dry place",
    supplier: "Healthy Foods Ltd.",
    lastRestocked: "2024-03-15",
    minimumStock: 5
  },
  {
    id: 2,
    name: "Cold Brew Coffee",
    category: "Drinks",
    quantity: 10,
    price: 95.97,
    image: "https://images.pexels.com/photos/5857500/pexels-photo-5857500.jpeg",
    description: "Smooth and refreshing cold brew coffee made from premium Arabica beans. Perfect for hot summer days.",
    brand: "Brew Master",
    volume: "250ml",
    expiryDate: "2024-09-30",
    ingredients: ["Arabica Coffee", "Water", "Natural Flavors"],
    nutritionalInfo: {
      calories: "5 kcal",
      protein: "0g",
      carbs: "1g",
      fat: "0g"
    },
    storage: "Refrigerate after opening",
    supplier: "Coffee Delights Inc.",
    lastRestocked: "2024-03-10",
    minimumStock: 8
  },
  {
    id: 3,
    name: "Organic Almonds",
    category: "Nuts",
    quantity: 20,
    price: 149.99,
    image: "https://images.pexels.com/photos/1295572/pexels-photo-1295572.jpeg",
    description: "Premium quality organic almonds, rich in nutrients and perfect for snacking or cooking.",
    brand: "Nature's Best",
    weight: "200g",
    expiryDate: "2024-11-30",
    ingredients: ["Organic Almonds"],
    nutritionalInfo: {
      calories: "160 kcal",
      protein: "6g",
      carbs: "6g",
      fat: "14g"
    },
    storage: "Store in a cool, dry place",
    supplier: "Organic Farms Co.",
    lastRestocked: "2024-03-05",
    minimumStock: 10
  },
  {
    id: 4,
    name: "Green Tea",
    category: "Drinks",
    quantity: 8,
    price: 79.5,
    image: "https://images.pexels.com/photos/1417945/pexels-photo-1417945.jpeg",
    description: "Premium Japanese green tea leaves, known for their antioxidant properties and refreshing taste.",
    brand: "Tea Master",
    weight: "100g",
    expiryDate: "2024-12-31",
    ingredients: ["Green Tea Leaves"],
    nutritionalInfo: {
      calories: "0 kcal",
      protein: "0g",
      carbs: "0g",
      fat: "0g"
    },
    storage: "Store in a cool, dry place away from sunlight",
    supplier: "Tea Gardens Ltd.",
    lastRestocked: "2024-03-01",
    minimumStock: 5
  },
  {
    id: 5,
    name: "Chocolate Bar",
    category: "Snacks",
    quantity: 25,
    price: 49.99,
    image: "https://images.pexels.com/photos/1326945/pexels-photo-1326945.jpeg",
    description: "Rich and creamy dark chocolate bar made with 70% cocoa. Perfect for chocolate lovers.",
    brand: "Sweet Delights",
    weight: "100g",
    expiryDate: "2024-10-31",
    ingredients: ["Cocoa Mass", "Sugar", "Cocoa Butter", "Vanilla Extract"],
    nutritionalInfo: {
      calories: "545 kcal",
      protein: "4g",
      carbs: "61g",
      fat: "31g"
    },
    storage: "Store in a cool, dry place",
    supplier: "Chocolate World Inc.",
    lastRestocked: "2024-03-12",
    minimumStock: 15
  }
];
}